<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{$t('general.order_management')}}</li>
          </ul>
        </nav>
      </div>

      <!-- <div id="shareSettings" class="uk-modal" uk-modal>
        <div class="uk-modal-dialog bggray">
          <div class="uk-padding-small" uk-grid>
            <h4> {{ $t('general.sharing_settings') }}</h4>
          </div>
          <div class="row p-4">
            <div class="col-lg-12">
              <div class="form-group row mb-2">
                <label class="col-md-6 col-form-label" for="website_keywords">
                  Onay Gerekli Değil
                  <i class="uil-info-circle" uk-tooltip="title: " title="" aria-expanded="false"></i></label>
                <div class="col-md-6">
                  <label class="uk-switch" for="default-1" v-if="experience_shareable != null">
                    <input type="checkbox" id="default-1" v-model="experience_shareable"
                      @change="handleExperienceSharing" />
                    <div class="uk-switch-slider"></div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-modal-footer uk-text-right bggray">
            <button class="uk-button uk-button-default small uk-modal-close" type="button">
              <i class="uil-times"></i> {{ $t("general.close") }}
            </button>
          </div>
        </div>
      </div> -->

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left"><span> {{$t('general.orders')}} </span></h2>
        </div>
        <!-- <div class="section-header-right">
          <a class="btn btn-secondary" style="background-color: red;" @click="removePosts()">
            <i class="uil-minus-circle"></i>Tüm Paylaşımları Sil
          </a>
        </div> -->
        <!-- <div class="section-header-right">
          <a class="btn btn-default dropdown-arrow text-white" uk-toggle="target: #shareSettings"
            uk-tooltip="Paylaşım Ayarları">
            {{ $t('general.sharing_settings') }}
          </a>
        </div> -->
      </div>

      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>

      <div class="card">
        <!-- Card header -->
        <div class="card-header actions-toolbar border-0">
          <div class="d-flex justify-content-between align-items-center">
            <!-- <h4 class="d-inline-block mb-0"></h4> -->
            <div class="row" style="width:100%">
              <div class=" col-md-1  search-icon ">
                <i class="uil-search"></i>
              </div>
              <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
                <input class="uk-search-input shadow-0 uk-form-small" type="search" v-model="filter.search"
                  :placeholder="$t('general.search')" autofocus="" />
                <!-- <a href="#" class="btn btn-icon btn-hover btn-circle" aria-expanded="false">
                <i class="uil-search"></i>
              </a>
              <div class="uk-drop" uk-drop="mode: hover; pos: right-center; offset: 0" style="left: 91px; top: 159.297px;">
                <form class="uk-search uk-search-navbar uk-width-1-1">
                  <input class="uk-search-input shadow-0 uk-form-small"
                  type="search"
                    v-model="filter.search"
                    :placeholder="$t('general.search')" autofocus="">
                </form>-->
              </div>
            </div>
            <div class="d-flex">
              <sort-dropdown :sort-options="sortOption"  @sort-selected="sortOrder" :title="sortTitle" />
            </div>
          </div>
        </div>
        <!-- Table -->
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col"> {{$t('profile.full_name')}} </th>
                <th scope="col"> {{$t('profile.email')}} </th>
                <th scope="col"> {{$t('general.product_name')}} </th>
                <th scope="col"> {{$t('general.product_type')}} </th>
                <th scope="col"> {{$t('general.order_date')}} </th>
                <th scope="col"> {{$t('general.price')}} </th>
                <th scope="col"> {{$t('general.status')}} </th>
                <th scope="col"> {{$t('general.invoice')}} </th>
                <th scope="col"> {{$t('general.add_invoice')}} </th>
              </tr>
            </thead>
            <tbody class="list">
              <!--user item-->
              <tr v-for="(order, index) in orders" :key="index">
                <td>{{ order.user.name }}</td>
                <td>{{ order.user.email }}</td>
                <td>{{ order.items[0].title }}</td>
                <td>{{ $t(`general.order.${order.items[0].type}`) }}</td>
                <td>{{ dateFormat(order.created_at) }}</td>
                <td> {{ formatPrice(order.items[0].price, order.items[0].currency)   }}</td>
                <td>{{ $t(`general.order.${order.status}`) }}</td>
                <td>
                  <span v-if="order.invoice_file" class="cursor-pointer text-primary" @click="showInvoiceModal(order)">
                    {{ $t('general.invoice') + page + index + '.pdf' }}
                  </span>
                  <span v-else>-</span>
                </td>
                <td>
                  <div class="upload-container">
                    <button class="btn btn-info upload-btn" @click="triggerFileInput(index)">
                      <i class="uil-upload"></i> {{ $t("general.upload") }}
                    </button>
                    <input type="file" ref="fileInputs" accept=".pdf" class="hidden-input"
                      @change="handleFileUpload($event, order.token)" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
        </div>
      </div>
    </div>
    <!-- Fatura Gösterme modalı -->
    <div id="invoice_modal" class="uk-modal-container" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-modal-body">
          <div v-if="selectedInvoice" class="invoice-container">
            <iframe :src="selectedInvoice" width="100%" height="500px" frameborder="0"></iframe>
            <div class="text-center mt-3">
              <button class="btn btn-primary" @click="downloadInvoice">
                <i class="uil-download-alt"></i> {{ $t('general.download') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import store from "@/core/services";
import moment from "moment";
import company_module, {
  ONLINE_USERS,
  MODULE_NAME as COMPANY_MODULE,
} from "@/core/services/store/company.module";
import {
  GET_ITEM_DETAIL_BY_ID,
  UPDATE_ITEM_BY_ID,
  GET_ITEMS
} from "@/core/services/store/REST.module";
import Pagination from "@/assets/components/Pagination";
const _COMPANY_MODULE = COMPANY_MODULE;
import axios from "axios";
import SortDropdown from "@/view/components/dropdown/SortDropdown.vue";
import { formatPrice } from "@/utils/money";
import { getEnvironmentMediaUrl } from "@/utils/imageHelper";

export default {
  name: "Orders",
  components: {
    DataTable,
    Pagination,
    SortDropdown
  },
  data() {
    return {
      orders: [],
      fileName: null,
      uploadError: null,
      companyUrl: "api/company/self",
      ordersUrl: "api/orders",
      sharesUrl: "api/shares-management",
      status_id: 1,
      pagination: null,
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      company: null,
      experience_shareable: null,
      per_page: 5,
      filter: {
        search: null,
        order: "desc",
        sort: "created_at",
      },
      sortTitle: this.$t("filters.order.sort"),
      sortOption: [
        {key: 'text-asc', sort: 'name', order: 'asc', label: this.$t("sorting.a_z")},
        {key: 'text-desc', sort: 'name', order: 'desc', label: this.$t("sorting.z_a")},
        {key: 'created_at-asc', sort: 'created_at', order: 'asc', label: this.$t("sorting.created_at_asc")},
        {key: 'created_at-desc', sort: 'created_at', order: 'desc', label: this.$t("sorting.created_at_desc")},
      ],
      selectedInvoice: null,
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
  },
  computed: {
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) { },
    },
  },
  methods: {
    formatPrice,
    getEnvironmentMediaUrl,
    dateFormat(date) {
      return moment(date).format("DD MMMM YYYY HH:mm")
    },
    triggerFileInput(index) {
      this.$refs.fileInputs[index].click();
    },
    handleFileUpload(event, token) {
      const file = event.target.files[0];
      if (!file) return;
      this.uploadPDF(file, token);
    },
    uploadPDF(file, token) {
      const formData = new FormData();
      formData.append('invoice_file', file);

      axios.post('/api/order-update-invoice/' + token, formData)
        .then(response => {
          window.location.reload();
        })
        .catch(error => {
          console.error('Dosya yükleme hatası:', error);
        });

    },
    getOrders() {
      let self = this;
      this.$store
        .dispatch(GET_ITEMS, {
          url: self.ordersUrl,
          acceptPromise: true,
           filters: {
             search: self.filter.search,
             page: self.page,
             per_page: self.per_page,
             sort: self.filter.sort,
             order: self.filter.order,
           },
        })
        .then((result) => {
          if (result) {
            this.pagination = result.data.meta;
            this.orders = result.data.data
          }
        });
    },
    handleExperienceSharing() {
      let self = this;
      let formData = new FormData();
      formData.append(
        "experience_shareable",
        self.experience_shareable === true ? 1 : 0
      );
      this.$store.dispatch(UPDATE_ITEM_BY_ID, {
        url: self.companySharingUrl + self.company.id,
        contents: formData,
        acceptPromise: false,
      });
    },
    sortOrder({ sort, order }) {
      let self = this;
      self.page = 1;
      self.filter.order = order;
      self.filter.sort = sort;
      this.getOrders();
    },
    setPage(page) {
      let self = this;
      self.page = page;
      this.getOrders();
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    showInvoiceModal(order) {
      this.selectedInvoice = this.getEnvironmentMediaUrl(order.invoice_file);
      UIkit.modal("#invoice_modal").show();
    },
    downloadInvoice() {
      if (this.selectedInvoice) {
        window.open(this.selectedInvoice, '_blank');
      }
    },
  },
  mounted() {
    this.getOrders();
  },
  beforeDestroy() {
    const modal = UIkit.modal("#shareSettings");
    if (modal) modal.$destroy(true);
  },
  watch: {
    "filter.search": function (val) {
      this.page = 1;
      this.debouncedFilterSearch();
    },
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.getOrders, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.cursor-pointer {
  cursor: pointer;
}

.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
  float: left;
}

.upload-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 6px;
  border: none;
}

.hidden-input {
  display: none;
}
</style>
